var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 81,
    viewBox: "0 0 180 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.401 7.169V10.0859H152.425C154.093 10.0859 156.595 10.0859 158.238 11.7542C159.881 13.4225 159.907 15.9248 159.907 17.5678V42.5918C159.907 44.26 159.907 46.7624 158.238 48.4054C156.57 50.0737 154.068 50.0737 152.425 50.0737H140.342C138.26 50.0737 135.545 50.0737 134.529 47.7785C133.487 45.4834 134.945 43.4006 136.197 41.7121L152.475 20.0247H127.451L117.442 33.3708C115.763 35.6053 114.312 37.5415 114.312 40.0439C114.312 42.5463 115.662 44.346 117.442 46.7169L119.944 50.0534C122.447 53.39 124.949 56.7265 128.285 58.3948C131.622 60.063 135.565 60.063 141.025 60.063H151.843C158.112 60.063 167.464 60.063 173.733 53.7944C180.002 47.5258 180.002 38.3756 180.002 35.0391V25.0295C180.002 21.693 180.002 12.5428 173.733 6.2742C167.464 0.00557759 158.112 0.00557759 151.843 0.00557759L134.554 1.67198e-05C132.886 -0.000488814 130.803 1.67535e-05 129.145 1.66828C127.477 3.33654 127.477 5.41934 127.477 7.07749",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5687 20.1108H122.34L92.5134 60.2502H67.7422L97.5687 20.1108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.1884C0 25.5201 0 23.4373 1.66826 21.7792C3.33653 20.121 5.41933 20.1109 7.07748 20.1109H48.9863C54.3955 20.1109 58.3892 20.1109 61.7257 21.7792C65.0622 23.4474 67.5394 26.784 70.067 30.1205L72.5694 33.457C74.3438 35.8229 75.6987 37.6277 75.6987 40.13C75.6987 42.6324 74.2478 44.5686 72.5694 46.8031L62.5598 60.1492H37.5359L53.8141 38.4618C55.0628 36.7935 56.5238 34.7107 55.4824 32.3954C54.441 30.1003 51.7313 30.1003 49.6687 30.1003H30.054V80.1481H10.0349V30.1003H0.0252767V27.1783",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo10);
export default __webpack_public_path__ + "static/media/logo-10.9628eb53078249322249427670c76d9a.svg";
export { ForwardRef as ReactComponent };